// Countries and major cities for logistics/shipping
// Comprehensive list for predictive autocomplete

export const COUNTRIES = [
  // Europe
  "Albania", "Andorra", "Austria", "Belarus", "Belgium", "Bosnia and Herzegovina",
  "Bulgaria", "Croatia", "Cyprus", "Czech Republic", "Denmark", "Estonia",
  "Finland", "France", "Germany", "Greece", "Hungary", "Iceland", "Ireland",
  "Italy", "Kosovo", "Latvia", "Liechtenstein", "Lithuania", "Luxembourg",
  "Malta", "Moldova", "Monaco", "Montenegro", "Netherlands", "North Macedonia",
  "Norway", "Poland", "Portugal", "Romania", "Russia", "San Marino", "Serbia",
  "Slovakia", "Slovenia", "Spain", "Sweden", "Switzerland", "Turkey", "Ukraine",
  "United Kingdom", "UK", "Vatican City",
  
  // Asia
  "Afghanistan", "Armenia", "Azerbaijan", "Bahrain", "Bangladesh", "Bhutan",
  "Brunei", "Cambodia", "China", "Georgia", "Hong Kong", "India", "Indonesia",
  "Iran", "Iraq", "Israel", "Japan", "Jordan", "Kazakhstan", "Kuwait",
  "Kyrgyzstan", "Laos", "Lebanon", "Macau", "Malaysia", "Maldives", "Mongolia",
  "Myanmar", "Nepal", "North Korea", "Oman", "Pakistan", "Palestine",
  "Philippines", "Qatar", "Saudi Arabia", "Singapore", "South Korea", "Sri Lanka",
  "Syria", "Taiwan", "Tajikistan", "Thailand", "Timor-Leste", "Turkmenistan",
  "United Arab Emirates", "UAE", "Uzbekistan", "Vietnam", "Yemen",
  
  // Africa
  "Algeria", "Angola", "Benin", "Botswana", "Burkina Faso", "Burundi", "Cameroon",
  "Cape Verde", "Central African Republic", "Chad", "Comoros", "Congo",
  "Democratic Republic of Congo", "Djibouti", "Egypt", "Equatorial Guinea",
  "Eritrea", "Eswatini", "Ethiopia", "Gabon", "Gambia", "Ghana", "Guinea",
  "Guinea-Bissau", "Ivory Coast", "Kenya", "Lesotho", "Liberia", "Libya",
  "Madagascar", "Malawi", "Mali", "Mauritania", "Mauritius", "Morocco",
  "Mozambique", "Namibia", "Niger", "Nigeria", "Rwanda", "São Tomé and Príncipe",
  "Senegal", "Seychelles", "Sierra Leone", "Somalia", "South Africa", "South Sudan",
  "Sudan", "Tanzania", "Togo", "Tunisia", "Uganda", "Zambia", "Zimbabwe",
  
  // Americas
  "Antigua and Barbuda", "Argentina", "Bahamas", "Barbados", "Belize", "Bolivia",
  "Brazil", "Canada", "Chile", "Colombia", "Costa Rica", "Cuba", "Dominica",
  "Dominican Republic", "Ecuador", "El Salvador", "Grenada", "Guatemala", "Guyana",
  "Haiti", "Honduras", "Jamaica", "Mexico", "Nicaragua", "Panama", "Paraguay",
  "Peru", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines",
  "Suriname", "Trinidad and Tobago", "United States", "USA", "Uruguay", "Venezuela",
  
  // Oceania
  "Australia", "Fiji", "Kiribati", "Marshall Islands", "Micronesia", "Nauru",
  "New Zealand", "Palau", "Papua New Guinea", "Samoa", "Solomon Islands", "Tonga",
  "Tuvalu", "Vanuatu"
];

// Major cities by country (for logistics/shipping)
export const CITIES_BY_COUNTRY = {
  "Slovenia": ["Ljubljana", "Maribor", "Celje", "Kranj", "Velenje", "Koper", "Novo Mesto", "Ptuj", "Trbovlje", "Kamnik"],
  "Croatia": ["Zagreb", "Split", "Rijeka", "Osijek", "Zadar", "Pula", "Slavonski Brod", "Karlovac", "Varaždin", "Šibenik"],
  "Italy": ["Rome", "Milan", "Naples", "Turin", "Palermo", "Genoa", "Bologna", "Florence", "Venice", "Verona", "Trieste", "Bari", "Catania", "Padua", "Livorno"],
  "Germany": ["Berlin", "Hamburg", "Munich", "Cologne", "Frankfurt", "Stuttgart", "Düsseldorf", "Leipzig", "Dortmund", "Essen", "Bremen", "Dresden", "Hanover", "Nuremberg", "Duisburg", "Bremerhaven"],
  "Austria": ["Vienna", "Graz", "Linz", "Salzburg", "Innsbruck", "Klagenfurt", "Villach", "Wels", "St. Pölten", "Dornbirn"],
  "Hungary": ["Budapest", "Debrecen", "Szeged", "Miskolc", "Pécs", "Győr", "Nyíregyháza", "Kecskemét", "Székesfehérvár"],
  "France": ["Paris", "Marseille", "Lyon", "Toulouse", "Nice", "Nantes", "Strasbourg", "Montpellier", "Bordeaux", "Lille", "Rennes", "Le Havre", "Dunkirk", "Rouen"],
  "Spain": ["Madrid", "Barcelona", "Valencia", "Seville", "Zaragoza", "Malaga", "Murcia", "Palma", "Las Palmas", "Bilbao", "Alicante", "Algeciras"],
  "Portugal": ["Lisbon", "Porto", "Amadora", "Braga", "Setúbal", "Coimbra", "Funchal", "Sines", "Leixões"],
  "Netherlands": ["Amsterdam", "Rotterdam", "The Hague", "Utrecht", "Eindhoven", "Tilburg", "Groningen", "Almere", "Breda"],
  "Belgium": ["Brussels", "Antwerp", "Ghent", "Charleroi", "Liège", "Bruges", "Namur", "Leuven", "Zeebrugge"],
  "Switzerland": ["Zurich", "Geneva", "Basel", "Lausanne", "Bern", "Winterthur", "Lucerne", "St. Gallen"],
  "United Kingdom": ["London", "Birmingham", "Manchester", "Glasgow", "Liverpool", "Leeds", "Sheffield", "Edinburgh", "Bristol", "Southampton", "Felixstowe", "Cardiff"],
  "UK": ["London", "Birmingham", "Manchester", "Glasgow", "Liverpool", "Leeds", "Sheffield", "Edinburgh", "Bristol", "Southampton", "Felixstowe", "Cardiff"],
  "Poland": ["Warsaw", "Krakow", "Lodz", "Wroclaw", "Poznan", "Gdansk", "Szczecin", "Bydgoszcz", "Lublin", "Gdynia"],
  "Czech Republic": ["Prague", "Brno", "Ostrava", "Pilsen", "Liberec", "Olomouc", "České Budějovice"],
  "Slovakia": ["Bratislava", "Košice", "Prešov", "Žilina", "Nitra", "Banská Bystrica", "Trnava", "Galanta", "Trenčín", "Martin", "Poprad", "Zvolen", "Považská Bystrica", "Michalovce", "Nové Zámky", "Spišská Nová Ves", "Komárno", "Levice", "Humenné", "Bardejov", "Liptovský Mikuláš", "Dunajská Streda", "Malacky", "Hlohovec", "Sereď", "Partizánske"],
  "Greece": ["Athens", "Thessaloniki", "Patras", "Piraeus", "Heraklion", "Larissa", "Volos"],
  "Turkey": ["Istanbul", "Ankara", "Izmir", "Bursa", "Antalya", "Adana", "Konya", "Mersin", "Gaziantep"],
  "Russia": ["Moscow", "Saint Petersburg", "Novosibirsk", "Yekaterinburg", "Kazan", "Nizhny Novgorod", "Vladivostok", "Kaliningrad"],
  "China": ["Shanghai", "Beijing", "Shenzhen", "Guangzhou", "Chengdu", "Hangzhou", "Wuhan", "Nanjing", "Tianjin", "Xi'an", "Qingdao", "Ningbo", "Dalian", "Xiamen", "Yantian", "Fuzhou"],
  "Hong Kong": ["Hong Kong", "Kowloon", "Tsuen Wan", "Sha Tin", "Tuen Mun"],
  "Japan": ["Tokyo", "Yokohama", "Osaka", "Nagoya", "Sapporo", "Kobe", "Fukuoka", "Kawasaki", "Kyoto"],
  "South Korea": ["Seoul", "Busan", "Incheon", "Daegu", "Daejeon", "Gwangju", "Ulsan"],
  "Singapore": ["Singapore"],
  "India": ["Mumbai", "Delhi", "Bangalore", "Hyderabad", "Chennai", "Kolkata", "Ahmedabad", "Pune", "Surat", "Jaipur", "Nhava Sheva"],
  "Vietnam": ["Ho Chi Minh City", "Hanoi", "Hai Phong", "Da Nang", "Can Tho", "Bien Hoa"],
  "Thailand": ["Bangkok", "Chiang Mai", "Pattaya", "Phuket", "Hat Yai", "Laem Chabang"],
  "Malaysia": ["Kuala Lumpur", "George Town", "Johor Bahru", "Ipoh", "Shah Alam", "Port Klang", "Penang"],
  "Indonesia": ["Jakarta", "Surabaya", "Bandung", "Medan", "Semarang", "Makassar", "Tanjung Priok"],
  "Philippines": ["Manila", "Quezon City", "Davao", "Cebu City", "Zamboanga", "Taguig"],
  "Taiwan": ["Taipei", "Kaohsiung", "Taichung", "Tainan", "Keelung"],
  "United Arab Emirates": ["Dubai", "Abu Dhabi", "Sharjah", "Ajman", "Ras Al Khaimah", "Jebel Ali"],
  "UAE": ["Dubai", "Abu Dhabi", "Sharjah", "Ajman", "Ras Al Khaimah", "Jebel Ali"],
  "Saudi Arabia": ["Riyadh", "Jeddah", "Mecca", "Medina", "Dammam", "Jubail"],
  "Egypt": ["Cairo", "Alexandria", "Giza", "Port Said", "Suez", "Luxor"],
  "South Africa": ["Johannesburg", "Cape Town", "Durban", "Pretoria", "Port Elizabeth", "Bloemfontein"],
  "Nigeria": ["Lagos", "Kano", "Ibadan", "Abuja", "Port Harcourt", "Benin City"],
  "Morocco": ["Casablanca", "Rabat", "Fes", "Marrakech", "Agadir", "Tangier"],
  "Kenya": ["Nairobi", "Mombasa", "Kisumu", "Nakuru", "Eldoret"],
  "United States": ["New York", "Los Angeles", "Chicago", "Houston", "Phoenix", "Philadelphia", "San Antonio", "San Diego", "Dallas", "San Francisco", "Seattle", "Miami", "Atlanta", "Boston", "Denver", "Long Beach", "Newark", "Savannah", "Charleston", "Norfolk"],
  "USA": ["New York", "Los Angeles", "Chicago", "Houston", "Phoenix", "Philadelphia", "San Antonio", "San Diego", "Dallas", "San Francisco", "Seattle", "Miami", "Atlanta", "Boston", "Denver", "Long Beach", "Newark", "Savannah", "Charleston", "Norfolk"],
  "Canada": ["Toronto", "Montreal", "Vancouver", "Calgary", "Edmonton", "Ottawa", "Winnipeg", "Quebec City", "Hamilton", "Halifax"],
  "Mexico": ["Mexico City", "Guadalajara", "Monterrey", "Puebla", "Tijuana", "León", "Veracruz", "Manzanillo", "Lazaro Cardenas"],
  "Brazil": ["São Paulo", "Rio de Janeiro", "Brasília", "Salvador", "Fortaleza", "Belo Horizonte", "Manaus", "Curitiba", "Santos", "Paranagua"],
  "Argentina": ["Buenos Aires", "Córdoba", "Rosario", "Mendoza", "La Plata", "Tucumán"],
  "Chile": ["Santiago", "Valparaíso", "Concepción", "Antofagasta", "Viña del Mar", "San Antonio"],
  "Colombia": ["Bogotá", "Medellín", "Cali", "Barranquilla", "Cartagena", "Buenaventura"],
  "Peru": ["Lima", "Arequipa", "Trujillo", "Chiclayo", "Callao"],
  "Australia": ["Sydney", "Melbourne", "Brisbane", "Perth", "Adelaide", "Gold Coast", "Canberra", "Newcastle", "Fremantle"],
  "New Zealand": ["Auckland", "Wellington", "Christchurch", "Hamilton", "Tauranga"],
  "Israel": ["Tel Aviv", "Jerusalem", "Haifa", "Rishon LeZion", "Ashdod", "Eilat"],
  "Qatar": ["Doha", "Al Wakrah", "Al Khor", "Mesaieed"],
  "Kuwait": ["Kuwait City", "Hawalli", "Salmiya", "Ahmadi"],
  "Bahrain": ["Manama", "Muharraq", "Riffa"],
  "Oman": ["Muscat", "Salalah", "Sohar", "Nizwa"],
  "Denmark": ["Copenhagen", "Aarhus", "Odense", "Aalborg", "Esbjerg", "Fredericia"],
  "Sweden": ["Stockholm", "Gothenburg", "Malmö", "Uppsala", "Västerås", "Helsingborg"],
  "Norway": ["Oslo", "Bergen", "Trondheim", "Stavanger", "Drammen", "Fredrikstad"],
  "Finland": ["Helsinki", "Espoo", "Tampere", "Vantaa", "Oulu", "Turku", "Kotka"],
  "Ireland": ["Dublin", "Cork", "Limerick", "Galway", "Waterford"],
  "Romania": ["Bucharest", "Cluj-Napoca", "Timișoara", "Iași", "Constanța", "Craiova"],
  "Bulgaria": ["Sofia", "Plovdiv", "Varna", "Burgas", "Ruse"],
  "Serbia": ["Belgrade", "Novi Sad", "Niš", "Kragujevac", "Subotica"],
  "Ukraine": ["Kyiv", "Kharkiv", "Odessa", "Dnipro", "Lviv", "Zaporizhzhia"],
  "Pakistan": ["Karachi", "Lahore", "Faisalabad", "Rawalpindi", "Gujranwala", "Peshawar"],
  "Bangladesh": ["Dhaka", "Chittagong", "Khulna", "Rajshahi", "Sylhet"],
  "Sri Lanka": ["Colombo", "Dehiwala-Mount Lavinia", "Moratuwa", "Kandy", "Galle"],
  "Myanmar": ["Yangon", "Mandalay", "Naypyidaw", "Mawlamyine"],
  "Cambodia": ["Phnom Penh", "Siem Reap", "Sihanoukville", "Battambang"]
};

// Search function for countries
export function searchCountries(query) {
  if (!query || query.length < 1) return [];
  const lowerQuery = query.toLowerCase();
  return COUNTRIES
    .filter(country => country.toLowerCase().startsWith(lowerQuery))
    .slice(0, 10);
}

// Search function for cities
export function searchCities(query, country = null) {
  if (!query || query.length < 1) return [];
  const lowerQuery = query.toLowerCase();
  
  if (country && CITIES_BY_COUNTRY[country]) {
    // Search within selected country
    return CITIES_BY_COUNTRY[country]
      .filter(city => city.toLowerCase().startsWith(lowerQuery))
      .slice(0, 10);
  }
  
  // Search across all cities
  const allCities = [];
  Object.entries(CITIES_BY_COUNTRY).forEach(([countryName, cities]) => {
    cities.forEach(city => {
      if (city.toLowerCase().startsWith(lowerQuery)) {
        allCities.push({ city, country: countryName });
      }
    });
  });
  
  return allCities.slice(0, 10);
}

// Get cities for a country
export function getCitiesForCountry(country) {
  return CITIES_BY_COUNTRY[country] || [];
}
